var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"login-home"}},[_c('public-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }